import React, { useState } from "react";
import { TablePageSubHeader } from "@design-system/TablePageSubHeader/TablePageSubHeader";
// oxlint-disable-next-line no-restricted-imports -- Legacy table migration/demo — do not copy into new code.
import {
    GridTable,
    GridTableHeader,
    GridTableRow,
} from "@design-system/Tables/GridTable/GridTable";
import {
    BooleanControl,
    TextControl,
    VariantGrid,
    VariantItem,
} from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./TablesPlayground.module.scss";

const reviewRows = [
    {
        id: "review-1",
        date: "Aug 8, 2026",
        description: "Adobe Creative Cloud",
        amount: "$59.99",
    },
    {
        id: "review-2",
        date: "Aug 7, 2026",
        description: "Delta Air Lines",
        amount: "$428.16",
    },
    {
        id: "review-3",
        date: "Aug 6, 2026",
        description: "Whole Foods Market",
        amount: "$84.27",
    },
];

export const TablePageSubHeaderPlayground = () => {
    const [statusLabel, setStatusLabel] = useState("Confirmed 3 of 12");
    const [hasBorderBottom, setHasBorderBottom] = useState(true);

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Content</h2>
                        <TextControl
                            label="Status label"
                            value={statusLabel}
                            onChange={setStatusLabel}
                        />
                    </section>
                    <section>
                        <h2>Style</h2>
                        <BooleanControl
                            label="Bottom border"
                            checked={hasBorderBottom}
                            onChange={setHasBorderBottom}
                        />
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary="Accrual review table context"
                width="full"
                output={JSON.stringify(
                    {
                        children: statusLabel,
                        borderBottom: hasBorderBottom,
                    },
                    null,
                    2,
                )}
            >
                <VariantGrid title="Table page status" columns="full">
                    <VariantItem label="TablePageSubHeader">
                        <div className={styles.subHeaderFrame}>
                            <TablePageSubHeader borderBottom={hasBorderBottom}>
                                {statusLabel}
                            </TablePageSubHeader>
                            <GridTable
                                noBorder
                                className={styles.subHeaderTable}
                                gridTemplateColumns="140px minmax(240px, 1fr) 140px"
                            >
                                <GridTableHeader
                                    columns={[
                                        {
                                            key: "date",
                                            label: "Date",
                                        },
                                        {
                                            key: "description",
                                            label: "Description",
                                        },
                                        {
                                            key: "amount",
                                            label: "Amount",
                                        },
                                    ]}
                                />
                                {reviewRows.map((transaction) => (
                                    <GridTableRow
                                        key={transaction.id}
                                        cells={[
                                            {
                                                key: "date",
                                                value: transaction.date,
                                            },
                                            {
                                                key: "description",
                                                value: transaction.description,
                                            },
                                            {
                                                key: "amount",
                                                value: transaction.amount,
                                                className: styles.amount,
                                            },
                                        ]}
                                    />
                                ))}
                            </GridTable>
                        </div>
                    </VariantItem>
                </VariantGrid>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
